import moment from 'moment'


export const formatDateTime = (date) => {

    if (date) {
        let currentDate = new Date(date)


        return moment(currentDate).format('MM/DD/YYYY hh:mm a')
    }

    return date


}

export const docLinkFormatter = (cell) => {

    if (cell) {

        const { label, url } = cell

        return <span > < a href = { url }
        rel = "noreferrer"
        target = "_blank" > { label } < /a></span >
    }

    return ''


}